import React from "react";
import { InputOption } from "../../../models/form/SanityFormInputField";
import { SanityInputFieldType } from "../../../models/form/SanityInputFieldType";

// Netlify requires all inputs to be rendered statically in the html, otherwise they won't show up
// in form submissions.
export const renderHiddenOptionValues = (options: InputOption[]) =>
  options.map((option, index) => (
    <React.Fragment key={index}>
      {option.inputs?.map(input => {
        let nestedOptions: InputOption[] = [];

        if (
          input._type === SanityInputFieldType.Checkboxes ||
          input._type === SanityInputFieldType.Dropdown ||
          input._type === SanityInputFieldType.RadioButtons ||
          input._type === SanityInputFieldType.PriceCheckboxes ||
          input._type === SanityInputFieldType.PriceRadioButtons
        ) {
          nestedOptions = input.options;
        }

        return (
          <React.Fragment key={input.slug.current}>
            {/* Netlify requires file upload fields to be of type 'file' when the site is crawled at deploy time */}
            {input._type === SanityInputFieldType.FileUpload && !input.secure ? (
              <input
                name={input.slug.current}
                id={input.slug.current}
                type="file"
                className="hidden"
              />
            ) : (
              <input name={input.slug.current} id={input.slug.current} type="hidden" />
            )}

            {renderHiddenOptionValues(nestedOptions)}
          </React.Fragment>
        );
      })}
    </React.Fragment>
  ));
